/**
 * features/invoices/useInvoices.ts
 * Live subscription to invoices, newest first.
 */
import { useEffect, useState } from 'react';
import { collection, onSnapshot, orderBy, query } from 'firebase/firestore';
import { db } from '@/lib/firebase';
import { COLLECTIONS, type Invoice } from '@/types';

export function useInvoices() {
  const [invoices, setInvoices] = useState<Invoice[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const q = query(collection(db, COLLECTIONS.invoices), orderBy('createdAt', 'desc'));
    return onSnapshot(
      q,
      (snap) => {
        setInvoices(snap.docs.map((d) => ({ id: d.id, ...(d.data() as Omit<Invoice, 'id'>) })));
        setLoading(false);
      },
      () => setLoading(false),
    );
  }, []);

  return { invoices, loading };
}
